import { createFeatureSelector } from '@ngrx/store';

export const membersState = createFeatureSelector<OLO.State, OLO.State.Members>('members');
